import { Dropdown } from "react-bootstrap";
import React from "react";
import styled from "styled-components";
import DotsIcon from "../icons/DotsIcon";

// region styles
const FooterActionsContainer = styled.div`
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100vw - 2rem);
    max-width: 420px;

    border-radius: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);

    display: grid;
    place-items: center;

    background-color: white;
    padding: 0;
    z-index: 9999999;

    .popup-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;

        background-color: var(--bs-primary);
        padding: 4px 12px;
        color: white;
        font-weight: bold;

        p {
            margin: 0;
        }

        button {
            border: none;
            background-color: transparent;
            padding: 0 0 0 12px;
            color: white;
            font-weight: bold;
        }
    }

    .buttons {
        padding: 12px;
        display: flex;
        gap: 12px;

        & > button,
        & > a,
        & > .actions > button {
            display: grid;
            place-items: center;
            font-size: 1rem;
            aspect-ratio: 1/1;
            width: 42px;
            height: 42px;
            border-radius: 50%;
            border: 1px solid #aaa;
            background-color: transparent;
            transition: all ease 300ms;
            cursor: pointer;

            // region reset bootstrap button style
            padding: 0;

            &::after {
                display: none;
            }

            // endregion

            svg {
                width: 24px;
                height: 24px;
                transition: all ease 300ms;

                path {
                    transition: all ease 300ms;
                    stroke: black;

                    &.fillable {
                        fill: black;
                    }
                }
            }

            &.show,
            &:hover {
                //background-color: #120E35;
                background-color: var(--bs-primary);

                svg {
                    path {
                        stroke: white;

                        &.fillable {
                            fill: white;
                        }
                    }
                }
            }

            &:disabled {
                opacity: 0.4;
                cursor: not-allowed;
                
                &:hover {
                    background-color: transparent;
                    
                    svg {
                        path {
                            stroke: black;

                            &.fillable {
                                fill: black;
                            }
                        }
                    }
                }
            }
        }
    }
`;

// endregion

export default function SelectionActionsPopup({
  selectedItemsLength,
  buttons,
  items,
  resetChecked,
}) {
  return (
    <FooterActionsContainer>
      <div className="popup-header">
        <p>{selectedItemsLength} éléments sélectionnés</p>
        <button onClick={resetChecked}>X</button>
      </div>
      <div className="buttons">
        {buttons.map((button, index) => (
          <button
            key={index}
            onClick={button.onClick}
            disabled={button.disabled}
            title={button.title || ""}
          >
            {button.label}
          </button>
        ))}
        {items && items.length > 0 && (
          <Dropdown className="actions">
            <Dropdown.Toggle>
              <DotsIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {items.map((item, index) =>
                item.divider ? (
                  <Dropdown.Divider key={index} />
                ) : (
                  <Dropdown.Item
                    key={index}
                    onClick={item.onClick}
                    disabled={item.disabled}
                  >
                    {item.label}
                  </Dropdown.Item>
                )
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </FooterActionsContainer>
  );
}
